<dx-box
    width="100%"
    height="100%"
    direction="col"
    [elementAttr]="{ id: 'boardApprovalBox' + (!widgetId ? '' : widgetId) }"
>
    <dxi-item baseSize="auto" *ngIf="!widgetId">
        <h2 class="page-header">
            {{ pageTitle }}
            <sup *ngIf="helpLink" class="page-help-icon">
                <a [href]="helpLink" target="_blank" [ngClass]="iconHelp"></a>
            </sup>
        </h2>
    </dxi-item>
    <dxi-item [ratio]="1">
        <div *dxTemplate>
            <dx-box width="100%" height="100%" direction="col" class="cc-white-background board-approval-container">
                <dxi-item baseSize="auto" *ngIf="!!showCommunitySelector">
                    <div *dxTemplate class="form-container">
                        <dx-form
                            #communitySelectorForm
                            [labelLocation]="formLabelLocation"
                            [showColonAfterLabel]="true"
                        >
                            <dxi-item>
                                <dxo-label text="Community"></dxo-label>
                                <div *dxTemplate>
                                    <ng-container *ngIf="!widgetId || (!!widgetId && filtersColCount >= 2)">
                                        <app-multi-column-selector
                                            #communitySelector
                                            [name]="'Community'"
                                            [gridSource]="communityList"
                                            [boxValue]="communityGridBoxValue"
                                            [valueExpr]="'communityId'"
                                            [displayExpr]="'communityName'"
                                            [columnDef]="communityColumns"
                                            [dropDownButtonTemplate]="'dropDownButton'"
                                            [dropDownOptions]="{ width: auto }"
                                            [placeholder]="'Select Community...'"
                                            [showHeaderFilters]="true"
                                            (gridSelectionEvent)="onCommunitySelection($event.selectedRow)"
                                        ></app-multi-column-selector>
                                    </ng-container>

                                    <ng-container *ngIf="!!widgetId && filtersColCount == 1">
                                        <app-multi-column-selector
                                            #communitySelector
                                            cssClass="widget-drop-down-box"
                                            [name]="'Community'"
                                            [gridSource]="communityList"
                                            [boxValue]="communityGridBoxValue"
                                            [valueExpr]="'communityId'"
                                            [displayExpr]="'communityName'"
                                            [columnDef]="communityColumns"
                                            [dropDownButtonTemplate]="'dropDownButton'"
                                            [dropDownOptions]="{ width: auto }"
                                            [placeholder]="'Select Community...'"
                                            [showHeaderFilters]="true"
                                            (gridSelectionEvent)="onCommunitySelection($event.selectedRow)"
                                        ></app-multi-column-selector>
                                    </ng-container>
                                </div>
                            </dxi-item>
                        </dx-form>
                    </div>
                </dxi-item>
                <dxi-item baseSize="auto">
                    <div *dxTemplate>
                        <span>
                            Board Approvals is an
                            <span><b>optional</b></span>
                            business process approval queue designed to systematically insert configured Board members
                            and or/ committee members into a defined work process prior to additional action on the
                            work. Configured business processes are identified by "Process" and must be configured by
                            your Community Association Manager prior to use. Completed approvals are highlighted green.
                            <span>
                                <b>
                                    Completed approvals may be configured to display under open approvals if they were
                                    recently finalized but the work items have progressed to the next step.
                                </b>
                            </span>
                            Click the blue help icon (question mark) for more information.
                        </span>
                    </div>
                </dxi-item>

                <!-- Show this filter section when board approval is being shown at its dedicated route -->
                <dxi-item baseSize="auto" *ngIf="!widgetId">
                    <div *dxTemplate class="toolbar-container">
                        <dx-toolbar width="100%">
                            <dxi-item location="before">
                                <dx-tabs
                                    class="cc-tabs"
                                    [width]="160"
                                    [dataSource]="tabItems"
                                    [(selectedItem)]="selectedTabItem"
                                    (onItemClick)="onTabItemClick($event)"
                                ></dx-tabs>
                            </dxi-item>

                            <!-- 
                                Action For Multiple Selection New design in v2. 
                                Agreed with Sandeep, Murthy on 22th Sept 2022 
                            -->

                            <dxi-item location="before">
                                <div *dxTemplate>
                                    <dx-drop-down-button
                                        text="Action For Multiple Selection"
                                        stylingMode="default"
                                        displayExpr="displayText"
                                        valueExpr="actionCode"
                                        itemTemplate="itemTemplate"
                                        noDataText="Loading Actions..."
                                        [dropDownOptions]="{ width: 300 }"
                                        [useSelectMode]="false"
                                        [disabled]="isMultiSelectionDisabled"
                                        [showArrowIcon]="false"
                                        [items]="multipleActions"
                                        (onItemClick)="onActionItemClick($event)"
                                    >
                                        <div *dxTemplate="let item of 'itemTemplate'">
                                            <div class="multiple-action-option-container">
                                                <div class="icon-container">
                                                    <i [ngClass]="item.icon"></i>
                                                </div>
                                                <div class="label-container">
                                                    {{ item.displayText }}
                                                </div>
                                            </div>
                                        </div>
                                    </dx-drop-down-button>
                                </div>
                            </dxi-item>

                            <dxi-item location="before">
                                <div *dxTemplate>
                                    <dx-radio-group
                                        class="maring-left-10px"
                                        valueExpr="value"
                                        displayExpr="displayText"
                                        layout="horizontal"
                                        [items]="taskTypes"
                                        [(value)]="queueParams.myTask"
                                        (onValueChanged)="onRefreshClick()"
                                    ></dx-radio-group>
                                </div>
                            </dxi-item>

                            <dxi-item location="center">
                                <div *dxTemplate class="flex-row">
                                    <span>Begin Due Date:&nbsp;</span>
                                    <dx-date-box
                                        type="date"
                                        [openOnFieldClick]="true"
                                        [showClearButton]="true"
                                        [(value)]="queueParams.beginDueDate"
                                        (onValueChanged)="onRefreshClick()"
                                    ></dx-date-box>
                                </div>
                            </dxi-item>

                            <dxi-item location="center">
                                <div *dxTemplate class="flex-row">
                                    <span>End Due Date:&nbsp;</span>
                                    <dx-date-box
                                        type="date"
                                        [min]="queueParams.beginDueDate"
                                        [openOnFieldClick]="true"
                                        [showClearButton]="true"
                                        [(value)]="queueParams.endDueDate"
                                        (onValueChanged)="onRefreshClick()"
                                    ></dx-date-box>
                                </div>
                            </dxi-item>

                            <dxi-item location="after">
                                <div *dxTemplate>
                                    <dx-button
                                        type="default"
                                        text="Refresh"
                                        hint="Refresh"
                                        [icon]="iconRefresh"
                                        (onClick)="onRefreshClick()"
                                    ></dx-button>
                                </div>
                            </dxi-item>
                        </dx-toolbar>
                    </div>
                </dxi-item>

                <!-- Show this filter section when board approval is being shown as widget in workspace -->
                <dxi-item baseSize="auto" *ngIf="!!widgetId">
                    <div *dxTemplate class="toolbar-container">
                        <dx-form width="100%" [colCount]="filtersColCount">
                            <dxi-item>
                                <div *dxTemplate>
                                    <dx-tabs
                                        class="cc-tabs"
                                        [width]="160"
                                        [dataSource]="tabItems"
                                        [(selectedItem)]="selectedTabItem"
                                        (onItemClick)="onTabItemClick($event)"
                                    ></dx-tabs>
                                </div>
                            </dxi-item>
                            <dxi-item>
                                <div *dxTemplate class="padding-top-3px">
                                    <dx-drop-down-button
                                        text="Action For Multiple Selection"
                                        stylingMode="default"
                                        displayExpr="displayText"
                                        valueExpr="actionCode"
                                        itemTemplate="itemTemplate"
                                        [dropDownOptions]="{ width: 300 }"
                                        [useSelectMode]="false"
                                        [disabled]="isMultiSelectionDisabled"
                                        [showArrowIcon]="false"
                                        [items]="multipleActions"
                                        (onItemClick)="onActionItemClick($event)"
                                    >
                                        <div *dxTemplate="let item of 'itemTemplate'">
                                            <div class="multiple-action-option-container">
                                                <div class="icon-container">
                                                    <i [ngClass]="item.icon"></i>
                                                </div>
                                                <div class="label-container">
                                                    {{ item.displayText }}
                                                </div>
                                            </div>
                                        </div>
                                    </dx-drop-down-button>
                                </div>
                            </dxi-item>
                            <dxi-item>
                                <div *dxTemplate class="padding-top-3px">
                                    <dx-radio-group
                                        class="maring-left-10px"
                                        valueExpr="value"
                                        displayExpr="displayText"
                                        layout="horizontal"
                                        [items]="taskTypes"
                                        [(value)]="queueParams.myTask"
                                        (onValueChanged)="onRefreshClick()"
                                    ></dx-radio-group>
                                </div>
                            </dxi-item>
                            <dxi-item>
                                <dxo-label text="Begin Due Date"></dxo-label>
                                <div *dxTemplate>
                                    <dx-date-box
                                        type="date"
                                        [width]="110"
                                        [openOnFieldClick]="true"
                                        [showClearButton]="true"
                                        [(value)]="queueParams.beginDueDate"
                                        (onValueChanged)="onRefreshClick()"
                                    ></dx-date-box>
                                </div>
                            </dxi-item>

                            <dxi-item>
                                <dxo-label text="End Due Date"></dxo-label>
                                <div *dxTemplate>
                                    <dx-date-box
                                        type="date"
                                        [width]="110"
                                        [min]="queueParams.beginDueDate"
                                        [openOnFieldClick]="true"
                                        [showClearButton]="true"
                                        [(value)]="queueParams.endDueDate"
                                        (onValueChanged)="onRefreshClick()"
                                    ></dx-date-box>
                                </div>
                            </dxi-item>

                            <dxi-item>
                                <div
                                    *dxTemplate
                                    [ngClass]="
                                        filtersColCount == 2 || filtersColCount == 6 ? 'cc-text-right' : 'cc-text-left'
                                    "
                                >
                                    <dx-button
                                        type="default"
                                        text="Refresh"
                                        hint="Refresh"
                                        [icon]="iconRefresh"
                                        (onClick)="onRefreshClick()"
                                    ></dx-button>
                                </div>
                            </dxi-item>
                        </dx-form>
                    </div>
                </dxi-item>

                <dxi-item [ratio]="1">
                    <div *dxTemplate>
                        <app-board-approval-grid
                            #boardApprovalGrid
                            [queueParams]="queueParams"
                            [mode]="selectedTabItem.name"
                            (onRowSelection)="onApprovalRowSelection($event)"
                        ></app-board-approval-grid>
                    </div>
                </dxi-item>
            </dx-box>
        </div>
    </dxi-item>
</dx-box>

<dx-load-panel
    *ngIf="loadingVisible"
    [message]="loadingMessage"
    [position]="{ of: 'body' }"
    [visible]="loadingVisible"
></dx-load-panel>

<app-muliple-board-approval-editor
    *ngIf="showMultipleBoardApproval"
    [visible]="showMultipleBoardApproval"
    [process]="selectedProcess"
    [recordsToProcess]="recordsToProcess"
    [queueParams]="queueParams"
    [actionTitle]="actionTitle"
    [multipleBoardApprovalAction]="multipleBoardApprovalAction"
    (onClose)="onMultipleBoardApprovalEditorClose($event)"
></app-muliple-board-approval-editor>

<cc-message-box #boardApprovalMessageBox></cc-message-box>
